import React from 'react';
import BalanceGridRow from '../types';
import { isMasterAccount, isParentAccount } from 'utils/methods';
import { Label } from 'semantic-ui-react';

type Props = {
  data: BalanceGridRow;
};

const MPRenderer = ({ data }: Props) => {
  return (
    (isMasterAccount(data) && <Label content="M" circular color="orange" />) ||
    (isParentAccount(data) && <Label content="P" circular color="blue" />)
  );
};

export default MPRenderer;
